import React from 'react'
import { Link } from 'gatsby'

const SmartLink = ({ to, children, className, callback }) => {
  const isExternal = /^https?:\/\//.test(to)
  if (isExternal) {
    return (
      <a
        href={to}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        onClick={(e) => {
          e.stopPropagation()
          callback && callback()
        }}
      >
        {children}
      </a>
    )
  }

  return (
    <Link
      to={to}
      className={className}
      onClick={(e) => {
        e.stopPropagation()
        callback && callback()
      }}
    >
      {children}
    </Link>
  )
}

export default SmartLink
